class Storage {
  constructor(instance) {
    if (typeof instance !== 'object') {
      throw new Error('Wrong storage instance provided');
    }

    this.storage = instance;
  }

  set(key, value) {
    this.storage.setItem(key, JSON.stringify(value));
  }

  get(key) {
    return JSON.parse(this.storage.getItem(key));
  }

  remove(key) {
    this.storage.removeItem(key);
  }

  clear() {
    this.storage.clear();
  }
}

export const LocalStorage = new Storage(window.localStorage);
export const SessionStorage = new Storage(window.sessionStorage);
